module.exports = __webpack_public_path__ + "media/images/logos/logo-corvinus-4e2cfa2df7e4e2d2f0ab89837a504690.svg";